import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

type Args = object;

// this step is shown for non-owner users only

export default class OnboardingStepsDboxIntroComponent extends Component<Args> {
	@service('onboarding') declare onboardingService: Service.Onboarding;
	@service('account') declare accountService: Service.Account;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.analyticsService.event(TrackingEvent.ONBOARDING_START);
	}

	get title() {
		const firstName = this.currentUserService.model?.firstName;
		return `Hey${firstName ? `, ${firstName}` : ''}! I'm Genie, your AI data analyst`;
	}

	get welcomeText() {
		return this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins
			? 'Welcome!'
			: 'Welcome to Databox!';
	}

	@action
	continue(): void {
		this.onboardingService.nextStep();
		void this.onboardingService.handleInvitedUserRedirectToApp();
	}
	<template>
		<div class="onboarding-genie-intro">
			<div class="onboarding-genie-intro__content">
				<CommonUiIconComponent
					@name="Genie"
					@size="2xl"
					@gradient="orange-violet"
					@class="onboarding-genie-intro__icon"
				/>
				<h2 class="onboarding-genie-intro__title">{{this.title}}</h2>
				<div class="onboarding-genie-intro__message">
					<p>{{this.welcomeText}}</p>
					<p>
						Ask me anything about your performance data. I'll pull the numbers, build
						dashboards, and flag what actually matters, so you're not digging for it
						yourself.
					</p>
					<p><strong>Ready to see what's in here?</strong></p>
				</div>
				<SubmitButtonComponent @text="Yes, let's start!" @onTrigger={{this.continue}} />
			</div>
		</div>
	</template>
}
